import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  resetPasswordSuccessMsg: null,
  resetPasswordError: null,
  loading: false,
};

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    resetPasswordSuccess(state, action) {
      state.resetPasswordSuccessMsg = action.payload;
    },
    resetPasswordError(state, action) {
      state.resetPasswordError = action.payload;
    },
    loadingData(state, action) {
      state.loading = action.payload;
    },
  },
});

export const { resetPasswordSuccess, resetPasswordError, loadingData } =
  resetPasswordSlice.actions;

export default resetPasswordSlice.reducer;
